import React from 'react';
import { motion } from 'framer-motion';
import { Calculator } from 'lucide-react';
export const BusinessSection = () => {
  return <section className="py-16 bg-white" data-id="element-45">
      <div className="container mx-auto px-6 max-w-md" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative" data-id="element-47">
          <div className="absolute inset-0 bg-gold/10 rounded-3xl transform rotate-2" data-id="element-48" />
          <div className="bg-white p-6 rounded-3xl shadow-soft border border-pink-light relative z-10" data-id="element-49">
            <div className="flex items-center gap-3 mb-5 pb-4 border-b border-pink-light" data-id="element-50">
              <div className="w-10 h-10 bg-pink-light rounded-lg flex items-center justify-center" data-id="element-51">
                <Calculator className="w-5 h-5 text-fuchsia" data-id="element-52" />
              </div>
              <div data-id="element-53">
                <h3 className="font-bold text-text-main text-sm" data-id="element-54">
                  Calculadora de Ingresos
                </h3>
                <p className="text-xs text-text-muted" data-id="element-55">
                  Proyección conservadora
                </p>
              </div>
            </div>

            <div className="space-y-3 text-sm" data-id="element-56">
              <div className="flex justify-between items-center" data-id="element-57">
                <span className="text-text-muted" data-id="element-58">Precio por sesión</span>
                <span className="font-bold text-text-main" data-id="element-59">$150.000 ARS</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-60">
                <span className="text-text-muted" data-id="element-61">Clientas por semana</span>
                <span className="font-bold text-text-main" data-id="element-62">10</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-63">
                <span className="text-text-muted" data-id="element-64">Semanas al mes</span>
                <span className="font-bold text-text-main" data-id="element-65">4</span>
              </div>

              <div className="pt-4 mt-2 border-t border-pink-light" data-id="element-66">
                <div className="flex justify-between items-end" data-id="element-67">
                  <div data-id="element-68">
                    <span className="block text-xs text-text-muted mb-0.5" data-id="element-69">
                      Ingresos Mensuales
                    </span>
                    <span className="text-2xl font-bold text-fuchsia" data-id="element-70">
                      $6.000.000
                    </span>
                  </div>
                  <span className="text-[10px] text-green-600 font-bold bg-green-50 px-2 py-1 rounded-md" data-id="element-71">
                    Rentabilidad Alta
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};